import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import type { Price} from "@@/shared/prices/price";
import { priceFactory } from "@@/shared/prices/price";
import { subtractFromPrice } from "@@/shared/prices/subtract-from-price";
import { sortBy } from "@@/utilities/sort";
import type { TimeStepResourceDiscount } from "./time-step-resource-discount";

//TEST TEST TEST NOT USED

const timeStepResourceDiscountCalculator =
    (discount: TimeStepResourceDiscount) =>
    (numberOfBookedTime: DurationInMinutes, price: Price) => {
        // const entitledItems = conditionFilter(discount, [item]);
        // console.log("entitledItems", entitledItems);
        // if (entitledItems.length !== 1 || item.acquireType !== "BOOKABLE")
        //     return item.price;

        const totalDiscount = discount.steps
            .sort(sortBy(s => s.step))
            .reduce((prev, current) => {
                if (current.step < numberOfBookedTime)
                    return prev + current.discount;
                return prev;
            }, 0);
        // console.log("discountPriceResource", totalDiscount, numberOfBookedTime);
        const discountPrice = subtractFromPrice(price, [
            priceFactory({
                amountIncludingVat: totalDiscount * 100,
                vat: price.vat,
            }),
        ]);
        // console.log("discountPriceResource", discountPrice);
        return discountPrice;
    };

export { timeStepResourceDiscountCalculator };
